exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\n  .help-modal .btn-lg {\n    font-size: 16px;\n  }\n}\n\n.night .help-modal-header .close {\n  color: #fff;\n}\n", "", {"version":3,"sources":["/app/client/src/templates/Challenges/components/help-modal.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAe;GACjB;CACF;;AAEA;EACE,YAAW;CACb","file":"help-modal.css","sourcesContent":["@media screen and (max-width: 767px) {\n  .help-modal .btn-lg {\n    font-size: 16px;\n  }\n}\n\n.night .help-modal-header .close {\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports
